/** Shared Tailwind prose classes for rendering Action Text rich content. */
export const PROSE_CLASSES =
  "prose prose-neutral max-w-none text-base/6 tracking-normal md:-tracking-[0.01em] prose-li:my-0 [&_li_p]:my-0";
